import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Image } from 'react-bootstrap';
import Aotmainlogo from '../../../assets/images/Aotmainlogo.svg';
import '../../../assets/scss/sections/_footer.scss';

const Footer = () => {
  return (
    <>
      <section id="footer_section">
        <Container className="footer_container">
          <Row>
            <Col>
              <div className="footer_wrapper">
                <div className="footer_logobar">
                  <a href="#">
                    <Image className="Aotmainlogo" src={Aotmainlogo} />
                  </a>
                </div>
                <div className="footer_menu">
                  <ul>
                    <li className="nav-item">
                      <a href="#" className="nav-link">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      {' '}
                      <a href="#" className="nav-link">
                        Services
                      </a>
                    </li>
                    <li className="nav-item">
                      {' '}
                      <a href="#" className="nav-link">
                        About
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#" className="nav-link">
                        Quote
                      </a>
                    </li>
                    <li className="nav-item">
                      {' '}
                      <a href="#" className="nav-link">
                        Contact
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#" className="nav-link">
                        Privacy policy
                      </a>
                    </li>
                    <li className="nav-item">
                      {' '}
                      <a href="#" className="nav-link">
                        Terms & conditions
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer_copyright text-center">
                  <p>
                    Arrive On Time Delivery <span> (972-242-7945 or 888-906-1453)</span> Copyright
                    @2023
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
Footer.propTypes = {
  t: PropTypes.func,
};
export { Footer };
